import { TweenMax } from "gsap";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import Layout from "../utils/Layout";
import VisualUtil from "../utils/VisualUtil";
import BaseView from "./BaseView";

/**
 * Abstraction for a single symbol.
 * A reel contains several of those.
 */
class ReelSymbol extends BaseView {
    // TODO COPY USEFUL LOGIC FROM EXTENDED FRAMEWORK INCLUDING DRAGON BONES INTEGRATION
    public id: number;
    public positionDefinitions: Map<string, IObjectConfig>;
    public zOrder: number;
    public reelIdx: number;
    public isFinal: boolean;
    protected bg: PIXI.Sprite;
    protected bgBlur: PIXI.Sprite;
    public symbol: PIXI.Sprite;
    protected symbolBlur: PIXI.Sprite;
    // protected frame: PIXI.Sprite;
    protected shineFilter: any;
    // protected symAnim: PIXI.extras.AnimatedSprite;
    protected bounds: IObjectConfig;

    public forceHidden: boolean = false;

    constructor() {
        super();
        // this.removeListener('removed', this.destroy, this);
    }

    create(
        symBounds: IObjectConfig,
        positionDefinitions: Map<string, IObjectConfig>
    ) {
        // const scaleRect = new PIXI.Rectangle(0, 0, Layout.scalePixels(symBounds.width), Layout.scalePixels(symBounds.height));
        this.bounds = symBounds;
        this.positionDefinitions = positionDefinitions;

        this.symbol = this.assets.getSprite("sym_empty");
        this.addChild(this.symbol);
        Layout.testSetHeight(this.symbol, symBounds.height);

        if (this.config.symbolBlur) {
            this.symbolBlur = this.assets.getSprite("sym_empty");
            this.symbolBlur.anchor.set(0.5, 0.5);
            this.addChild(this.symbolBlur);
            this.symbolBlur.alpha = 0;
            Layout.testSetHeight(this.symbolBlur, symBounds.height);
        }

        const uniform = {
            position: { type: "f", value: 0 },
            intensity: { type: "f", value: 1 },
        };
        this.shineFilter = new PIXI.Filter(
            null,
            PIXI.loader.resources.shine.data,
            uniform
        );

        // this.symAnim = new PIXI.extras.AnimatedSprite([this.assets.getTexture('sym_empty')]);
        // this.symAnim.anchor.set(.5, .5);
        // this.addChild(this.symAnim);
        // this.symAnim.visible = false;
        // this.symAnim.loop = false;

        this.symbol.filters = [];

        // if (this.config.symbolFrame)
        // {
        //     this.frame = this.assets.getSprite("win_frame");
        //     this.frame.anchor.set(.5, .5);
        //     this.addChild(this.frame);
        //     this.frame.alpha = 0;
        // }
    }

    buildBackground() {
        if (!this.bg && !this.config.symbolAssetsMap[this.id].background) {
            return;
        }

        const textureId =
            this.config.symbolAssetsMap[this.id].background || "sym_empty";
        if (!this.bg) {
            this.bg = this.assets.getSprite(textureId);
            this.bg.anchor.set(0.5, 0.5);
            this.addChildAt(this.bg, 0);
        } else {
            this.bg.texture = this.assets.getTexture(textureId);
        }

        Layout.testSetHeight(this.bg, this.bounds.height);
        if (this.config.symbolBlur) {
            const blurtextureId =
                this.config.symbolAssetsMap[this.id].background_blur ||
                "sym_empty";
            if (!this.bgBlur) {
                this.bgBlur = this.assets.getSprite(blurtextureId);
                this.bgBlur.anchor.set(0.5, 0.5);
                this.addChildAt(this.bgBlur, this.children.indexOf(this.bg));
            } else {
                this.bgBlur.texture = this.assets.getTexture(blurtextureId);
            }

            this.bgBlur.alpha = 0;
            Layout.testSetHeight(this.bgBlur, this.bounds.height);
        }
    }

    setBlurLevel(level: number) {
        // const inverseLevel = Math.min(1, (2 - level * 2));
        //
        // if (this.bg && this.bgBlur)
        // {
        //     this.bg.alpha = inverseLevel;
        //     this.bgBlur.alpha = level;
        // }
        //
        // if (this.config.symbolBlur)
        // {
        //     this.symbol.alpha = inverseLevel;
        //     this.symbolBlur.alpha = level;
        // }
    }

    setId(id: number) {
        this.id = id;
        const anchor = this.config.symAnchors[id];
        const anchorX = anchor ? anchor.x : 0.5;
        const anchorY = anchor ? anchor.y : 0.5;

        const symSpriteId: number | string = this.config.symbolAssetsMap[
            this.id
        ].name;

        const textureBounds = this.positionDefinitions
            ? this.positionDefinitions.get("sym_" + symSpriteId)
            : undefined;

        this.symbol.anchor.set(anchorX, anchorY);
        this.symbol.texture = this.assets.getTexture("sym_" + symSpriteId);
        if (textureBounds) {
            Layout.testSetWidth(this.symbol, textureBounds.width);
            if (this.id === 0) {
                // debugger;
            }
            let boundX = this.bounds.x + this.bounds.width / 2;
            let textX = textureBounds.x + textureBounds.width / 2;
            this.symbol.x = Math.ceil(
                Layout.scalePixels(
                    textX - boundX
                )
            );
            this.symbol.y = Math.ceil(
                Layout.scalePixels(
                    -this.bounds.y -
                        this.bounds.height / 2 +
                        textureBounds.y +
                        textureBounds.height / 2
                )
            );
            // console.log()
        } else {
            console.warn(
                "PSD warning! Texture : 'sym_" +
                    symSpriteId +
                    "' doesn't have bounds"
            );
        }
        if (this.config.symbolBlur) {
            if (this.config.skipBlur.indexOf(id) !== -1) {
                this.symbolBlur.texture = this.assets.getTexture(
                    "sym_" + symSpriteId
                );
            } else {
                this.symbolBlur.texture = this.assets.getTexture(
                    "sym_" + symSpriteId + "_blur"
                );
            }
            this.symbolBlur.anchor.set(anchorX, anchorY);
            if (textureBounds) {
                Layout.testSetHeight(this.symbolBlur, textureBounds.height);
                let boundX = this.bounds.x + this.bounds.width / 2;
                let textX = textureBounds.x + textureBounds.width / 2;
                const offsetX = Math.ceil(Layout.scalePixels(textX - boundX));
                // const offsetX = Math.ceil(Layout.scalePixels(this.bounds.x + this.bounds.width / 2 - textureBounds.x - textureBounds.width / 2));
                this.symbolBlur.x = offsetX;
                const offsetY = Math.ceil(
                    Layout.scalePixels(
                        -this.bounds.y -
                            this.bounds.height / 2 +
                            textureBounds.y +
                            textureBounds.height / 2
                    )
                );
                this.symbolBlur.y = offsetY;
            }
        }
        // this.symbol.anchor.set(anchorX, anchorY);
        this.buildBackground();
    }

    getId(): number {
        return this.id;
    }

    public hide(animated: boolean = false) {
        if (animated) {
            if (this.symbol) {
                TweenMax.to(this.symbol, 0.5, {
                    alpha: 0,
                    onComplete: () => {
                        this.symbol.visible = false;
                        this.symbol.alpha = 1;
                    },
                });
            }
        } else {
            if (this.symbol) {
                this.symbol.visible = false;
            }
        }
    }
    public show(animated: boolean = false) {
        if (!this.forceHidden) {
            if (animated) {
                if (this.symbol) {
                    this.symbol.alpha = 0;
                    this.symbol.visible = true;
                    TweenMax.to(this.symbol, 0.5, {
                        alpha: 1,
                    });
                }
            } else {
                if (this.symbol) {
                    this.symbol.visible = true;
                }
            }
        }
    }

    public showWin(loop: boolean = false) {
        VisualUtil.tintTween(this.symbol, 0xffffff, 0.2);
        this.hide();
    }

    blackening(loop: boolean = false) {
        return VisualUtil.blackeningTween(this.symbol, 0x5a5a5a, 0.8);
       // this.hide();
    }

    setupAnimation(loop: boolean = false, animName = "_anim"): boolean {
        const symSpriteId: number | string = this.config.symbolAssetsMap[
            this.id
        ].name;
        let textureBounds = this.positionDefinitions.get(
            "sym_" + symSpriteId + animName
        );
        if (!textureBounds) {
            textureBounds = this.positionDefinitions.get("sym_" + symSpriteId);
        }
        let animID = animName != "_anim" ? symSpriteId + animName : symSpriteId;

        const animData = this.config.animData[animID];

        if (animData && animData.numFrames) {
            this.hide();
            // this.symAnim.textures = animTextures;
            // this.symAnim.animationSpeed = animTextures.length / 90;
        } else if (animData && animData.fade) {
            // this.symAnim.textures = animTextures;
            // this.symAnim.animationSpeed = animTextures.length / 90;
        } else if (animData && animData.shine) {
            this.symbol.filters = [this.shineFilter];

            this.shineFilter.uniforms.position = 0;
            this.shineFilter.uniforms.intensity = 0;
        }

        return textureBounds != null && animData != null;
    }

    // playHitAnimation(animData: any) {
    //     //TODO Remove and use other play animation method
    //     // const animAnchor = animData.anchor;
    //     // if (animAnchor) {
    //     //     this.symAnim.anchor.set(animAnchor.x, animAnchor.y);
    //     // }
    //     // else {
    //     //     this.symAnim.anchor.set(.5, .5);
    //     // }

    //     // this.symAnim.visible = true;
    //     // this.symAnim.alpha = 1;
    //     // this.symAnim.loop = false;

    //     // const frameData = animData.frames;
    //     // const fadeData = animData.fade;
    //     // if (frameData) {
    //     //     this.symAnim.textures =
    //     //         this.assets.generateFrames(frameData.prefix, frameData.pad, frameData.start, frameData.end);
    //     //     this.symAnim.animationSpeed = animData.speed ? animData.speed : 1;
    //     //     this.symAnim.onComplete = this.hideSymAnim.bind(this);
    //     //     this.symAnim.gotoAndPlay(0);
    //     // }
    //     // else if (fadeData) {
    //     //     const duration = fadeData.duration ? fadeData.duration : .1;
    //     //     this.symAnim.textures = [this.assets.getTexture(fadeData.textureName)];
    //     //     TweenMax.from(this.symAnim, duration, { alpha: 0, yoyo: true, repeat: 1 });
    //     // }
    // }

    protected playAnimation(animaName?: string): Promise<boolean> {
        return new Promise((res) => {
            let symSpriteId: number | string = this.config.symbolAssetsMap[
                this.id
            ].name;
            if (animaName && animaName != "_anim") {
                symSpriteId = symSpriteId + animaName;
            }
            const animData = this.config.animData[symSpriteId];
            let resComplete = () => res(true);

            if (animData.shine) {
                TweenMax.to(this.shineFilter.uniforms, 1.5, {
                    position: 1,
                    yoyo: true,
                    repeat: animData.loop ? -1 : 3,
                    onComplete: resComplete,
                });
                TweenMax.to(this.shineFilter.uniforms, 0.2, {
                    intensity: 2,
                    onComplete: resComplete,
                });
                if (!animData.loop) {
                    TweenMax.to(this.shineFilter.uniforms, 0.2, {
                        intensity: 0,
                        delay: 6,
                        onComplete: resComplete,
                    });
                }
            } else {
                res(true);
            }
        });
    }

    fade() {
        // this.symAnim.visible = false;
        this.show();
        this.symbol.filters = [];
        VisualUtil.tintTween(this.symbol, this.config.symbolTintColor, 0.2);
    }

    stopAnimation() {
        // this.symAnim.stop();

        this.show();
        // this.symAnim.visible = false;

        TweenMax.killTweensOf(this.shineFilter.uniforms);
        // TweenMax.killTweensOf(this.symAnim);

        const hideTime = 0.2;

        if (this.symbol.filters.indexOf(this.shineFilter) !== -1) {
            TweenMax.to(this.shineFilter.uniforms, hideTime, {
                intensity: 0,
                onComplete: this.removeFilters,
                onCompleteScope: this,
            });
        }
    }

    hideWin() {
        VisualUtil.tintTween(this.symbol, 0xffffff, 0.2);
        this.show();
        // this.stopAnimation();

        // if (this.frame)
        // {
        //     TweenMax.to(this.frame, .1, {alpha: 0});
        // }
    }

    removeFilters() {
        this.symbol.filters = [];
    }

    getReelIdx() {
        return this.reelIdx;
    }
}

export default ReelSymbol;
